(() => {
  const query = new URL(location.href).searchParams.get('msk_mail_offer');
  let renderedToken = '';
  try { renderedToken = JSON.parse(document.getElementById('msk-mail-price-state')?.textContent || '""'); } catch { /* untrusted cart state */ }
  const token = query || renderedToken;
  const isMailCode = code => /^MSK-MAIL(?:[A-F0-9]{32}[01]|-[A-F0-9]{64})$/i.test(String(code));
  if (!token || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products|collections|cart)(?:\/|$)/i.test(location.pathname)) return;
  const reloadKey = `msk-mail-price-reload:${location.pathname}:${token}`;
  const reload = () => {
    // A rejected/blocked cart cookie must not trap the visitor in a reload loop.
    if (sessionStorage.getItem(reloadKey)) throw new Error('CartContextNotRetained');
    sessionStorage.setItem(reloadKey, '1');
    location.replace(location.href);
  };
  let ready = false;
  const buy = 'form[action*="/cart/add"],form[action*="/checkout"],[name="checkout"],a[href*="/checkout"]';
  const block = event => {
    if (!ready && event.composedPath().some(element => element instanceof Element && element.closest(buy))) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  };
  // Run before the later MitID window-capture guard as well as form handlers.
  // A visible header drawer must not start checkout while prices are pending.
  window.addEventListener('submit', block, true);
  window.addEventListener('click', block, true);
  const style = document.createElement('style');
  style.textContent = 'html.msk-mail-price-loading main{visibility:hidden}';
  document.head.appendChild(style);
  document.documentElement.classList.add('msk-mail-price-loading');
  const pending = document.createElement('p');
  pending.setAttribute('role', 'status');
  pending.dataset.mskMailPricePending = '';
  pending.textContent = 'Kontrollerer tilbuddets priser …';
  pending.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1000;padding:16px 24px;background:#faf7f2;color:#254d32;border-radius:8px;text-align:center';
  const showPending = () => {
    if (document.documentElement.classList.contains('msk-mail-price-loading')) document.body.appendChild(pending);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showPending, { once: true }); else showPending();
  const fail = () => {
    document.documentElement.classList.remove('msk-mail-price-loading');
    const show = () => {
      const existing = document.querySelector('[data-msk-mail-price-error]');
      if (existing) return;
      const error = document.createElement('p');
      error.dataset.mskMailPriceError = ''; error.setAttribute('role', 'alert');
      error.textContent = 'Tilbudsprisen kunne ikke klargøres. Genindlæs siden for at prøve igen. Der er ikke lagt noget i kurven.';
      (document.querySelector('product-form') || document.querySelector('main') || document.body).prepend(error);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show, { once: true }); else show();
  };
  const controller = new AbortController();
  // Shopify registration and readback share the app's throttled Admin API
  // queue. A valid production response can take longer than twelve seconds.
  const timeout = setTimeout(() => controller.abort(), 45000);
  const read = async (url, options) => {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal, ...options });
    if (!response.ok) throw new Error('Unavailable');
    return response.json();
  };
  const run = async () => {
    if (!/^[A-Za-z0-9_-]{43}$/.test(token)) throw new Error('Invalid');
    // Both old clearance tokens and ordinary mail tokens are accepted, but
    // neither endpoint can accept a visitor-supplied price or product list.
    let context;
    for (const kind of ['mail', 'oprydning']) {
      const response = await fetch(`/apps/kundeprofil/tilbud/${kind}/${encodeURIComponent(token)}/context.json`,
        { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (response.status === 410) continue;
      if (!response.ok) throw new Error('Unavailable');
      context = await response.json(); break;
    }
    const root = window.Shopify?.routes?.root || '/';
    if (!context && !query) {
      // An expired remembered context returns to normal prices; an explicit
      // expired mail link is blocked instead of silently promising old prices.
      const expiredCart = await read(`${root}cart.js`);
      const remainingCodes = (expiredCart.discount_codes || []).map(item => item.code).filter(code => !isMailCode(code));
      await read(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: remainingCodes.join(','), attributes: { _msk_mail_price_offer: '' } }) });
      reload(); return;
    }
    if (!context || context.token !== token || context.currencyCode !== 'DKK'
      || !Array.isArray(context.codes) || context.codes.length !== 2
      || !context.codes.every((code, partition) => /^MSK-MAIL[A-F0-9]{32}[01]$/.test(code)
        && code.endsWith(String(partition)) && code.slice(0, -1) === context.codes[0].slice(0, -1))
      || !Number.isFinite(Date.parse(context.expiresAt))
      || Date.parse(context.expiresAt) <= Date.now()
      || !Array.isArray(context.items) || !context.items.length || context.items.length > 240
      || !context.items.every(item => /^[1-9]\d{0,19}$/.test(String(item.variantId))
        && /^[1-9]\d{0,19}$/.test(String(item.productId)) && Number.isSafeInteger(item.priceCents) && item.priceCents > 0)
      || new Set(context.items.map(item => String(item.variantId))).size !== context.items.length) throw new Error('Inactive');
    const before = await read(`${root}cart.js`);
    const codes = (before.discount_codes || []).map(item => item.code).filter(code => !isMailCode(code));
    if (codes.length + context.codes.length > 5) throw new Error('DiscountCapacity');
    const cart = await read(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: [...codes, ...context.codes].join(','), attributes: { _msk_mail_price_offer: token } }) });
    if (cart.attributes?._msk_mail_price_offer !== token || cart.currency !== 'DKK'
      || !context.codes.every(code => (cart.discount_codes || []).some(item => item.code.toUpperCase() === code))) throw new Error('NotApplied');
    // An owner with no discounted lines is legitimately inapplicable. Verify
    // exact resulting prices instead; never add a dummy discount to force it.
    for (const line of cart.items || []) {
      const offered = context.items.find(item => String(item.variantId) === String(line.variant_id) && String(item.productId) === String(line.product_id));
      if (offered && (!Number.isSafeInteger(line.final_price) || line.final_price > offered.priceCents)) throw new Error('PriceMismatch');
    }
    if (renderedToken !== token) {
      // Re-render the unchanged normal product page with its validated cart
      // context. Keep the token in the URL so sharing the link still works.
      reload(); return;
    }
    try { sessionStorage.removeItem(reloadKey); } catch { /* no reload is needed */ }
    ready = true;
    document.documentElement.classList.remove('msk-mail-price-loading');
  };
  run().catch(fail).finally(() => { clearTimeout(timeout); pending.remove(); });
})();
